/** Helpers tareas operativas despacho. */

export const TASK_STATUS_OPTIONS = [
  { value: "pending", label: "Pendiente" },
  { value: "requested", label: "Solicitado" },
  { value: "in_progress", label: "En proceso" },
  { value: "done", label: "Terminado" },
  { value: "not_applicable_this_period", label: "No aplicó este mes" },
];

export const TASK_ADVANCE_OPTIONS = [
  { value: "requested", label: "Marcar solicitado" },
  { value: "in_progress", label: "Marcar en proceso" },
  { value: "done", label: "Marcar terminado" },
  { value: "not_applicable_this_period", label: "No aplicó este mes" },
];

export const NOT_APPLICABLE_TASK_COMMENTS = [
  "No hubo operaciones en este periodo.",
  "No se detectaron retenciones en este periodo.",
  "Cliente sin movimientos.",
  "No hubo nómina.",
  "No hubo operaciones REPSE.",
  "Otro.",
];

export function taskStatusLabel(status) {
  const found = TASK_STATUS_OPTIONS.find((o) => o.value === status);
  if (found) return found.label;
  const legacy = {
    pendiente: "Pendiente",
    en_proceso: "En proceso",
    completada: "Terminado",
    cancelada: "Cancelado",
    no_aplico_este_mes: "No aplicó este mes",
  };
  return legacy[status] || status || "—";
}

export function taskStatusVariant(status) {
  const norm = String(status || "").toLowerCase();
  if (norm === "done" || norm === "completada") return "secondary";
  if (norm === "not_applicable_this_period" || norm === "no_aplico_este_mes") return "outline";
  if (norm === "in_progress" || norm === "en_proceso") return "default";
  if (norm === "requested" || norm === "solicitado") return "default";
  return "destructive";
}

export function groupTasksByClient(tasks) {
  const map = new Map();
  for (const t of tasks || []) {
    const key = t.client_name || t.fiscal_client_id || "Sin cliente";
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(t);
  }
  return [...map.entries()].sort(([a], [b]) => a.localeCompare(b, "es"));
}

export function groupTasksByAuxiliar(tasks) {
  const map = new Map();
  for (const t of tasks || []) {
    const key = t.assigned_to_user_id || "__sin_asignar__";
    const label = t.assigned_to_name || (key === "__sin_asignar__" ? "Sin asignar" : key);
    if (!map.has(key)) map.set(key, { label, rows: [] });
    map.get(key).rows.push(t);
  }
  return [...map.values()]
    .sort((a, b) => a.label.localeCompare(b.label, "es"))
    .map((g) => [g.label, g.rows]);
}
